export default __webpack_public_path__ + "static/media/small-add-item.722f0ae6.svg";